module.exports = __webpack_public_path__ + "static/media/mindset-large@3x.f883d4b9.png";